const templateText = `
<!DOCTYPE html>
<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
 <meta charset="UTF-8" />
 <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
 <!--[if !mso]><!-- -->
 <meta http-equiv="X-UA-Compatible" content="IE=edge" />
 <!--<![endif]-->
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
 <meta name="x-apple-disable-message-reformatting" />
 <link href="https://fonts.googleapis.com/css?family=Fira+Sans:ital,wght@0,400;0,400;0,700" rel="stylesheet" />
 <title>Untitled</title>
 <!-- Made with Postcards Email Builder by Designmodo -->
 <!--[if !mso]><!-- -->
 <style>
 @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 400; src: local('Fira Sans Regular'), local('FiraSans-Regular'), url(https://fonts.gstatic.com/s/firasans/v10/va9E4kDNxMZdWfMOD5VvmojLazX3dGTP.woff2) format('woff2'); unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 400; src: local('Fira Sans Regular'), local('FiraSans-Regular'), url(https://fonts.gstatic.com/s/firasans/v10/va9E4kDNxMZdWfMOD5Vvk4jLazX3dGTP.woff2) format('woff2'); unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 400; src: local('Fira Sans Regular'), local('FiraSans-Regular'), url(https://fonts.gstatic.com/s/firasans/v10/va9E4kDNxMZdWfMOD5VvmYjLazX3dGTP.woff2) format('woff2'); unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 400; src: local('Fira Sans Regular'), local('FiraSans-Regular'), url(https://fonts.gstatic.com/s/firasans/v10/va9E4kDNxMZdWfMOD5Vvl4jLazX3dA.woff2) format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }
                         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 500; src: local('Fira Sans Medium'), local('FiraSans-Medium'), url(https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnZKveSxf6Xl7Gl3LX.woff2) format('woff2'); unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 500; src: local('Fira Sans Medium'), local('FiraSans-Medium'), url(https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnZKveQhf6Xl7Gl3LX.woff2) format('woff2'); unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 500; src: local('Fira Sans Medium'), local('FiraSans-Medium'), url(https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnZKveSBf6Xl7Gl3LX.woff2) format('woff2'); unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 500; src: local('Fira Sans Medium'), local('FiraSans-Medium'), url(https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnZKveRhf6Xl7Glw.woff2) format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }
                         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 700; src: local('Fira Sans Bold'), local('FiraSans-Bold'), url(https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnLK3eSxf6Xl7Gl3LX.woff2) format('woff2'); unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 700; src: local('Fira Sans Bold'), local('FiraSans-Bold'), url(https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnLK3eQhf6Xl7Gl3LX.woff2) format('woff2'); unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 700; src: local('Fira Sans Bold'), local('FiraSans-Bold'), url(https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnLK3eSBf6Xl7Gl3LX.woff2) format('woff2'); unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF; }
         @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 700; src: local('Fira Sans Bold'), local('FiraSans-Bold'), url(https://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnLK3eRhf6Xl7Glw.woff2) format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }
 </style>
 <!--<![endif]-->
 <style>
 html, body { margin: 0 !important; padding: 0 !important; min-height: 100% !important; width: 100% !important; -webkit-font-smoothing: antialiased; }
         * { -ms-text-size-adjust: 100%; }
         #outlook a { padding: 0; }
         .ReadMsgBody, .ExternalClass { width: 100%; }
         .ExternalClass, .ExternalClass p, .ExternalClass td, .ExternalClass div, .ExternalClass span, .ExternalClass font { line-height: 100%; }
         table, td, th { mso-table-lspace: 0 !important; mso-table-rspace: 0 !important; border-collapse: collapse; }
         u + .body table, u + .body td, u + .body th { will-change: transform; }
         body, td, th, p, div, li, a, span { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; mso-line-height-rule: exactly; }
         img { border: 0; outline: 0; line-height: 100%; text-decoration: none; -ms-interpolation-mode: bicubic; }
         a[x-apple-data-detectors] { color: inherit !important; text-decoration: none !important; }
         .body .pc-project-body { background-color: transparent !important; }
                 
 
         @media (min-width: 621px) {
             .pc-lg-hide {  display: none; } 
             .pc-lg-bg-img-hide { background-image: none !important; }
         }
 </style>
 <style>
 @media (max-width: 620px) {
 .pc-project-body {min-width: 0px !important;}
 .pc-project-container {width: 100% !important;}
 .pc-sm-hide, .pc-w620-gridCollapsed-1 > tbody > tr > .pc-sm-hide {display: none !important;}
 .pc-sm-bg-img-hide {background-image: none !important;}
 .pc-w620-padding-25-35-0-35 {padding: 25px 35px 0px 35px !important;}
 .pc-w620-padding-10-35-10-35 {padding: 10px 35px 10px 35px !important;}
 .pc-w620-radius-35-35-35-35 {border-radius: 35px 35px 35px 35px !important;}
 table.pc-w620-spacing-0-10-0-10 {margin: 0px 10px 0px 10px !important;}
 td.pc-w620-spacing-0-10-0-10,th.pc-w620-spacing-0-10-0-10{margin: 0 !important;padding: 0px 10px 0px 10px !important;}
 .pc-w620-padding-0-0-0-0 {padding: 0px 0px 0px 0px !important;}
 .pc-w620-padding-10-30-10-30 {padding: 10px 30px 10px 30px !important;}
 .pc-w620-padding-25-35-25-35 {padding: 25px 35px 25px 35px !important;}
 .pc-w620-itemsSpacings-40-40 {padding-left: 20px !important;padding-right: 20px !important;padding-top: 20px !important;padding-bottom: 20px !important;}
 table.pc-w620-spacing-0-0-50-0 {margin: 0px 0px 50px 0px !important;}
 td.pc-w620-spacing-0-0-50-0,th.pc-w620-spacing-0-0-50-0{margin: 0 !important;padding: 0px 0px 50px 0px !important;}
 .pc-w620-valign-top {vertical-align: top !important;}
 td.pc-w620-halign-center,th.pc-w620-halign-center {text-align: center !important;}
 table.pc-w620-halign-center {float: none !important;margin-right: auto !important;margin-left: auto !important;}
 img.pc-w620-halign-center {margin-right: auto !important;margin-left: auto !important;}
 div.pc-w620-align-center,th.pc-w620-align-center,a.pc-w620-align-center,td.pc-w620-align-center {text-align: center !important;text-align-last: center !important;}
 table.pc-w620-align-center {float: none !important;margin-right: auto !important;margin-left: auto !important;}
 img.pc-w620-align-center {margin-right: auto !important;margin-left: auto !important;}
 .pc-w620-itemsSpacings-10-0 {padding-left: 5px !important;padding-right: 5px !important;padding-top: 0px !important;padding-bottom: 0px !important;}
 .pc-w620-valign-middle {vertical-align: middle !important;}
 .pc-w620-padding-35-35-35-35 {padding: 35px 35px 35px 35px !important;}
 
 .pc-w620-gridCollapsed-1 > tbody,.pc-w620-gridCollapsed-1 > tbody > tr,.pc-w620-gridCollapsed-1 > tr {display: inline-block !important;}
 .pc-w620-gridCollapsed-1.pc-width-fill > tbody,.pc-w620-gridCollapsed-1.pc-width-fill > tbody > tr,.pc-w620-gridCollapsed-1.pc-width-fill > tr {width: 100% !important;}
 .pc-w620-gridCollapsed-1.pc-w620-width-fill > tbody,.pc-w620-gridCollapsed-1.pc-w620-width-fill > tbody > tr,.pc-w620-gridCollapsed-1.pc-w620-width-fill > tr {width: 100% !important;}
 .pc-w620-gridCollapsed-1 > tbody > tr > td,.pc-w620-gridCollapsed-1 > tr > td {display: block !important;width: auto !important;padding-left: 0 !important;padding-right: 0 !important;margin-left: 0 !important;}
 .pc-w620-gridCollapsed-1.pc-width-fill > tbody > tr > td,.pc-w620-gridCollapsed-1.pc-width-fill > tr > td {width: 100% !important;}
 .pc-w620-gridCollapsed-1.pc-w620-width-fill > tbody > tr > td,.pc-w620-gridCollapsed-1.pc-w620-width-fill > tr > td {width: 100% !important;}
 .pc-w620-gridCollapsed-1 > tbody > .pc-grid-tr-first > .pc-grid-td-first,.pc-w620-gridCollapsed-1 > .pc-grid-tr-first > .pc-grid-td-first {padding-top: 0 !important;}
 .pc-w620-gridCollapsed-1 > tbody > .pc-grid-tr-last > .pc-grid-td-last,.pc-w620-gridCollapsed-1 > .pc-grid-tr-last > .pc-grid-td-last {padding-bottom: 0 !important;}
 
 .pc-w620-gridCollapsed-0 > tbody > .pc-grid-tr-first > td,.pc-w620-gridCollapsed-0 > .pc-grid-tr-first > td {padding-top: 0 !important;}
 .pc-w620-gridCollapsed-0 > tbody > .pc-grid-tr-last > td,.pc-w620-gridCollapsed-0 > .pc-grid-tr-last > td {padding-bottom: 0 !important;}
 .pc-w620-gridCollapsed-0 > tbody > tr > .pc-grid-td-first,.pc-w620-gridCollapsed-0 > tr > .pc-grid-td-first {padding-left: 0 !important;}
 .pc-w620-gridCollapsed-0 > tbody > tr > .pc-grid-td-last,.pc-w620-gridCollapsed-0 > tr > .pc-grid-td-last {padding-right: 0 !important;}
 
 .pc-w620-tableCollapsed-1 > tbody,.pc-w620-tableCollapsed-1 > tbody > tr,.pc-w620-tableCollapsed-1 > tr {display: block !important;}
 .pc-w620-tableCollapsed-1.pc-width-fill > tbody,.pc-w620-tableCollapsed-1.pc-width-fill > tbody > tr,.pc-w620-tableCollapsed-1.pc-width-fill > tr {width: 100% !important;}
 .pc-w620-tableCollapsed-1.pc-w620-width-fill > tbody,.pc-w620-tableCollapsed-1.pc-w620-width-fill > tbody > tr,.pc-w620-tableCollapsed-1.pc-w620-width-fill > tr {width: 100% !important;}
 .pc-w620-tableCollapsed-1 > tbody > tr > td,.pc-w620-tableCollapsed-1 > tr > td {display: block !important;width: auto !important;}
 .pc-w620-tableCollapsed-1.pc-width-fill > tbody > tr > td,.pc-w620-tableCollapsed-1.pc-width-fill > tr > td {width: 100% !important;box-sizing: border-box !important;}
 .pc-w620-tableCollapsed-1.pc-w620-width-fill > tbody > tr > td,.pc-w620-tableCollapsed-1.pc-w620-width-fill > tr > td {width: 100% !important;box-sizing: border-box !important;}
 }
 @media (max-width: 520px) {
 .pc-w520-padding-25-30-0-30 {padding: 25px 30px 0px 30px !important;}
 .pc-w520-padding-10-30-10-30 {padding: 10px 30px 10px 30px !important;}
 .pc-w520-padding-0-0-0-0 {padding: 0px 0px 0px 0px !important;}
 .pc-w520-padding-10-25-10-25 {padding: 10px 25px 10px 25px !important;}
 .pc-w520-padding-25-30-25-30 {padding: 25px 30px 25px 30px !important;}
 .pc-w520-padding-30-30-30-30 {padding: 30px 30px 30px 30px !important;}
 }
 </style>
 <!--[if !mso]><!-- -->
 <style>
 @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 400; src: url('https://fonts.gstatic.com/s/firasans/v17/va9E4kDNxMZdWfMOD5VvmYjN.woff') format('woff'), url('https://fonts.gstatic.com/s/firasans/v17/va9E4kDNxMZdWfMOD5VvmYjL.woff2') format('woff2'); } @font-face { font-family: 'Fira Sans'; font-style: normal; font-weight: 700; src: url('https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnLK3eSBf8.woff') format('woff'), url('https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnLK3eSBf6.woff2') format('woff2'); }
 </style>
 <!--<![endif]-->
 <!--[if mso]>
    <style type="text/css">
        .pc-font-alt {
            font-family: Arial, Helvetica, sans-serif !important;
        }
    </style>
    <![endif]-->
 <!--[if gte mso 9]>
    <xml>
        <o:OfficeDocumentSettings>
            <o:AllowPNG/>
            <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
    </xml>
    <![endif]-->
</head>
<body class="body pc-font-alt" style="width: 100% !important; min-height: 100% !important; margin: 0 !important; padding: 0 !important; font-weight: normal; color: #2D3A41; mso-line-height-rule: exactly; -webkit-font-smoothing: antialiased; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-variant-ligatures: normal; text-rendering: optimizeLegibility; -moz-osx-font-smoothing: grayscale; background-color: #f4f4f4;" bgcolor="#f4f4f4">
 <table class="pc-project-body" style="table-layout: fixed; width: 100%; min-width: 600px; background-color: #f4f4f4;" bgcolor="#f4f4f4" border="0" cellspacing="0" cellpadding="0" role="presentation">
  <tr>
   <td align="center" valign="top">
    <table class="pc-project-container" align="center" style="width: 600px; max-width: 600px;" border="0" cellpadding="0" cellspacing="0" role="presentation">
     <tr>
      <td style="padding: 20px 0px 20px 0px;" align="left" valign="top">
       <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
        <tr>
         <td valign="top">
          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
           <tr>
            <td valign="top" class="pc-w520-padding-25-30-0-30 pc-w620-padding-25-35-0-35" style="padding: 25px 40px 0px 40px; height: unset; background-color: #ffffff;" bgcolor="#ffffff">
             <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
              <tr>
               <td valign="top" align="left">
                <div class="pc-font-alt" style="text-decoration: none;">
                 <div style="font-size: 32px;line-height: 42px;text-align:left;text-align-last:left;color:#434343;letter-spacing:-0.2px;font-weight:700;font-style:normal;">
                  <div><span style="font-family: 'Fira Sans', Arial, Helvetica, sans-serif;">{{TITLE}}</span>
                  </div>
                 </div>
                </div>
               </td>
              </tr>
             </table>
            </td>
           </tr>
          </table>
         </td>
        </tr>
        <tr>
         <td valign="top">
          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
           <tr>
            <td valign="top" class="pc-w520-padding-10-30-10-30 pc-w620-padding-10-35-10-35" style="padding: 10px 40px 10px 40px; height: unset; background-color: #ffffff;" bgcolor="#ffffff">
             <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
              <tr>
               <td valign="top" align="left">
                <div class="pc-font-alt" style="text-decoration: none;">
                 <div style="font-size: 15px;line-height: 21px;text-align:left;text-align-last:left;color:#333333;letter-spacing:-0.2px;font-weight:400;font-style:normal;">
                  <div><span style="font-family: 'Fira Sans', Arial, Helvetica, sans-serif;">{{BODY_TEXT}}</span>
                  </div>
                  <div style="line-height:21px;font-size:15px;">
                   <br>
                  </div>
                  <div style="line-height:21px;font-size:15px;">
                   <br>
                  </div>
                 </div>
                </div>
               </td>
              </tr>
             </table>
            </td>
           </tr>
          </table>
         </td>
        </tr>
        <tr>
         <td valign="top">
          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
           <tr>
            <td valign="top" class="pc-w520-padding-0-0-0-0 pc-w620-padding-0-0-0-0" style="height: unset; background-color: #ffffff;" bgcolor="#ffffff">
             <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
              <tr>
               <td class="pc-w620-spacing-0-10-0-10" align="left" valign="top" style="padding: 0px 10px 0px 10px;">
                <a class="pc-font-alt" href="{{LOOM_VIDEO_LINK}}" target="_blank" style="text-decoration: none;">
                 <img src="https://cloudfilesdm.com/postcards/0d9c21a6da868093aff95e04746e56bf.png" class="pc-w620-radius-35-35-35-35" width="580" height="auto" style="display: block; outline: 0; line-height: 100%; -ms-interpolation-mode: bicubic; min-width: 111.3402061872px; min-height: 1px; width:100%; height: auto; border-radius: 99px 99px 99px 99px; border: 0;" alt="" />
                </a>
               </td>
              </tr>
             </table>
            </td>
           </tr>
          </table>
         </td>
        </tr>
        <tr>
         <td valign="top">
          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
           <tr>
            <td valign="top" class="pc-w520-padding-10-25-10-25 pc-w620-padding-10-30-10-30" style="padding: 10px 40px 10px 40px; height: unset; background-color: #ffffff;" bgcolor="#ffffff">
             <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
              <tr>
               <td valign="top">
                <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                 <tr>
                  <td valign="top" style="line-height: 1px; font-size: 1px; border-bottom: 2px solid #D9D9D9;">&nbsp;</td>
                 </tr>
                </table>
               </td>
              </tr>
             </table>
            </td>
           </tr>
          </table>
         </td>
        </tr>
        <tr>
         <td valign="top">
          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
           <tr>
            <td valign="top" class="pc-w520-padding-25-30-25-30 pc-w620-padding-25-35-25-35" style="padding: 25px 40px 25px 40px; height: unset; background-color: #ffffff;" bgcolor="#ffffff">
             <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
              <tr>
               <td valign="top">
                <div>
                 <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#FFFFFF;background-color:#FFFFFF;width:100%">
                  <tbody>
                   <tr>
                    <td>
                     <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="wrapper-outlook" role="presentation" style="width:640px;" width="640" bgcolor="#FFFFFF" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                     <div style="margin:0px auto;max-width:640px">
                      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
                       <tbody>
                        <tr>
                         <td style="direction:ltr;font-size:0px;padding:0;text-align:center">
                          <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="640px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:640px;" width="640" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                          <div style="margin:0px auto;max-width:640px">
                           <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
                            <tbody>
                             <tr>
                              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center">
                               <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:640px;" ><![endif]-->
                               <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top" width="100%">
                                 <tbody>
                                  <tr>
                                   <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word">
                                    <div style="font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:22px;font-weight:normal;line-height:32px;text-align:left;color:#000000">What is your overall satisfaction with our SAAS product?</div>
                                   </td>
                                  </tr>
                                  <tr>
                                   <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word">
                                    <table cellpadding="0" cellspacing="0" width="100%" border="0" style="color:#000000;font-family:Ubuntu,Helvetica,Arial,sans-serif;font-size:13px;line-height:22px;table-layout:auto;width:100%;border:none">
                                     <tbody>
                                      <tr>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=0" style="display:block;color:#0445AF;text-decoration:none;text-align:center">0</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=1" style="display:block;color:#0445AF;text-decoration:none;text-align:center">1</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=2" style="display:block;color:#0445AF;text-decoration:none;text-align:center">2</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=3" style="display:block;color:#0445AF;text-decoration:none;text-align:center">3</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=4" style="display:block;color:#0445AF;text-decoration:none;text-align:center">4</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=5" style="display:block;color:#0445AF;text-decoration:none;text-align:center">5</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                      </tr>
                                      <tr>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=6" style="display:block;color:#0445AF;text-decoration:none;text-align:center">6</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=7" style="display:block;color:#0445AF;text-decoration:none;text-align:center">7</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=8" style="display:block;color:#0445AF;text-decoration:none;text-align:center">8</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=9" style="display:block;color:#0445AF;text-decoration:none;text-align:center">9</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                       <td align="center" style="padding:4px;width:41px">
                                        <table style="width:100%">
                                         <tbody>
                                          <tr>
                                           <td align="center" valign="middle" style="border:1px #0445AF solid;border-radius:3px;background-color:rgba(4, 69, 175, 0.1);font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;font-size:16px;height:56px;width:100%"><a href="https://form.typeform.com/to/GhhNQXfT?typeform-medium=embed-email#answers-8322d5c0-a601-46dd-a841-8c8c8d73ff80=10" style="display:block;color:#0445AF;text-decoration:none;text-align:center">10</a>
                                           </td>
                                          </tr>
                                         </tbody>
                                        </table>
                                       </td>
                                      </tr>
                                     </tbody>
                                    </table>
                                   </td>
                                  </tr>
                                 </tbody>
                                </table>
                               </div>
                               <!--[if mso | IE]></td></tr></table><![endif]-->
                              </td>
                             </tr>
                            </tbody>
                           </table>
                          </div>
                          <!--[if mso | IE]></td></tr></table></td></tr><tr><td class="" width="640px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:640px;" width="640" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                          <div style="margin:0px auto;max-width:640px">
                           <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
                            <tbody>
                             <tr>
                              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center">
                               <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:640px;" ><![endif]-->
                               <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top" width="100%">
                                 <tbody>
                                  <tr>
                                   <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word">
                                    <div style="font-family:Helvetica,Arial;font-size:12px;font-weight:normal;line-height:1;text-align:center;color:#000000">Powered by <a href="https://www.typeform.com" style="color:#000000;text-decoration:none;font-weight:bold">Typeform</a>
                                    </div>
                                   </td>
                                  </tr>
                                 </tbody>
                                </table>
                               </div>
                               <!--[if mso | IE]></td></tr></table><![endif]-->
                              </td>
                             </tr>
                            </tbody>
                           </table>
                          </div>
                          <!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
                         </td>
                        </tr>
                       </tbody>
                      </table>
                     </div>
                     <!--[if mso | IE]></td></tr></table><![endif]-->
                    </td>
                   </tr>
                  </tbody>
                 </table>
                </div>
               </td>
              </tr>
             </table>
            </td>
           </tr>
          </table>
         </td>
        </tr>
        <tr>
         <td valign="top">
          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
           <tr>
            <td valign="top" class="pc-w520-padding-30-30-30-30 pc-w620-padding-35-35-35-35" style="padding: 40px 40px 40px 40px; height: unset; background-color: #1b1b1b;" bgcolor="#1b1b1b">
             <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
              <tr>
               <td class="pc-w620-spacing-0-0-50-0" style="padding: 0px 0px 69px 0px;">
                <table class="pc-width-fill pc-w620-gridCollapsed-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                 <tr class="pc-grid-tr-first pc-grid-tr-last">
                  <td class="pc-grid-td-first pc-w620-itemsSpacings-40-40" align="left" valign="top" style="width: 50%; padding-top: 0px; padding-right: 20px; padding-bottom: 0px; padding-left: 0px;">
                   <table style="width: 100%;" border="0" cellpadding="0" cellspacing="0" role="presentation">
                    <tr>
                     <td class="pc-w620-halign-center pc-w620-valign-top" align="left" valign="top">
                      <table class="pc-w620-halign-center" align="left" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                       <tr>
                        <td class="pc-w620-halign-center" align="left" valign="top">
                         <table border="0" cellpadding="0" cellspacing="0" role="presentation" class="pc-w620-halign-center" align="left">
                          <tr>
                           <td valign="top" class="pc-w620-align-center" align="left">
                            <div class="pc-font-alt pc-w620-align-center" style="line-height: 143%; letter-spacing: -0.2px; font-family: 'Fira Sans', Arial, Helvetica, sans-serif; font-size: 14px; font-weight: normal; color: #d8d8d8; text-align: left; text-align-last: left;">
                             King street, 2901 Marmara road, New&zwnj;york, WA 98122&zwnj;-1090</div>
                           </td>
                          </tr>
                         </table>
                        </td>
                       </tr>
                      </table>
                     </td>
                    </tr>
                   </table>
                  </td>
                  <td class="pc-grid-td-last pc-w620-itemsSpacings-40-40" align="left" valign="top" style="width: 50%; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 20px;">
                   <table style="width: 100%;" border="0" cellpadding="0" cellspacing="0" role="presentation">
                    <tr>
                     <td class="pc-w620-halign-center pc-w620-valign-top" align="right" valign="top">
                      <table class="pc-w620-halign-center" align="right" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                       <tr>
                        <td class="pc-w620-halign-center" align="right" valign="top">
                         <table class="pc-w620-halign-center" align="right" border="0" cellpadding="0" cellspacing="0" role="presentation">
                          <tr>
                           <td class="pc-w620-valign-middle pc-w620-halign-center" align="right">
                            <table class="pc-w620-halign-center" align="right" border="0" cellpadding="0" cellspacing="0" role="presentation">
                             <tr>
                              <td valign="top">
                               <table class="pc-width-hug pc-w620-gridCollapsed-0 pc-w620-halign-center" align="right" border="0" cellpadding="0" cellspacing="0" role="presentation">
                                <tr class="pc-grid-tr-first pc-grid-tr-last">
                                 <td class="pc-grid-td-first pc-w620-itemsSpacings-10-0" valign="middle" style="width: 33.33%; padding-top: 0px; padding-right: 10px; padding-bottom: 0px; padding-left: 0px;">
                                  <img src="https://cloudfilesdm.com/postcards/0698c860b69827e09d54c6dee67c35a9.png" class="" width="15" height="15" style="display: block; border: 0; outline: 0; line-height: 100%; -ms-interpolation-mode: bicubic; width: 15px; height: 15px;" alt="" />
                                 </td>
                                 <td class="pc-w620-itemsSpacings-10-0" valign="middle" style="width: 33.33%; padding-top: 0px; padding-right: 10px; padding-bottom: 0px; padding-left: 10px;">
                                  <img src="https://cloudfilesdm.com/postcards/52f04ccb7ccb3a7cd6d84aeecdc63696.png" class="" width="15" height="15" style="display: block; border: 0; outline: 0; line-height: 100%; -ms-interpolation-mode: bicubic; width: 15px; height: 15px;" alt="" />
                                 </td>
                                 <td class="pc-grid-td-last pc-w620-itemsSpacings-10-0" valign="middle" style="width: 33.33%; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 10px;">
                                  <img src="https://cloudfilesdm.com/postcards/293e174e097d13c8322e2200ff1949b0.png" class="" width="15" height="15" style="display: block; border: 0; outline: 0; line-height: 100%; -ms-interpolation-mode: bicubic; width: 15px; height: 15px;" alt="" />
                                 </td>
                                </tr>
                               </table>
                              </td>
                             </tr>
                            </table>
                           </td>
                          </tr>
                         </table>
                        </td>
                       </tr>
                      </table>
                     </td>
                    </tr>
                   </table>
                  </td>
                 </tr>
                </table>
               </td>
              </tr>
             </table>
             <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
              <tr>
               <td align="center">
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation">
                 <tr>
                  <td valign="top">
                   <table class="pc-width-hug pc-w620-gridCollapsed-0" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation">
                    <tr class="pc-grid-tr-first pc-grid-tr-last">
                     <td class="pc-grid-td-first pc-w620-itemsSpacings-10-0" valign="top" style="padding-top: 0px; padding-right: 10px; padding-bottom: 0px; padding-left: 0px;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation">
                       <tr>
                        <td align="center" valign="top">
                         <table align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                          <tr>
                           <td align="center" valign="top">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" align="center">
                             <tr>
                              <td valign="top" align="left">
                               <div class="pc-font-alt" style="line-height: 143%; letter-spacing: -0.2px; font-family: 'Fira Sans', Arial, Helvetica, sans-serif; font-size: 14px; font-weight: 500; color: #1595e7; text-align: left; text-align-last: left;">
                                Manage Preferences</div>
                              </td>
                             </tr>
                            </table>
                           </td>
                          </tr>
                         </table>
                        </td>
                       </tr>
                      </table>
                     </td>
                     <td class="pc-grid-td-last pc-w620-itemsSpacings-10-0" valign="top" style="padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 10px;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation">
                       <tr>
                        <td align="center" valign="top">
                         <table align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                          <tr>
                           <td align="center" valign="top">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" align="center">
                             <tr>
                              <td valign="top" align="left">
                               <div class="pc-font-alt" style="line-height: 143%; letter-spacing: -0.2px; font-family: 'Fira Sans', Arial, Helvetica, sans-serif; font-size: 14px; font-weight: 500; color: #1595e7; text-align: left; text-align-last: left;">
                                Unsubscribe</div>
                              </td>
                             </tr>
                            </table>
                           </td>
                          </tr>
                         </table>
                        </td>
                       </tr>
                      </table>
                     </td>
                    </tr>
                   </table>
                  </td>
                 </tr>
                </table>
               </td>
              </tr>
             </table>
            </td>
           </tr>
          </table>
         </td>
        </tr>
        <tr>
         <td>
          <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
           <tr>
            <td align="center" valign="top" style="padding-top: 20px; padding-bottom: 20px; vertical-align: top;">
             <a href="https://postcards.email/?uid=Mjk1NzE1&type=footer" target="_blank" style="text-decoration: none; overflow: hidden; border-radius: 2px; display: inline-block;">
              <img src="https://cloudfilesdm.com/postcards/promo-footer-dark.jpg" width="198" height="46" alt="Made with (o -) postcards" style="width: 198px; height: auto; margin: 0 auto; border: 0; outline: 0; line-height: 100%; -ms-interpolation-mode: bicubic; vertical-align: top;">
             </a>
             <img src="https://api-postcards.designmodo.com/tracking/mail/promo?uid=Mjk1NzE1" width="1" height="1" alt="" style="display:none; width: 1px; height: 1px;">
            </td>
           </tr>
          </table>
         </td>
        </tr>
       </table>
      </td>
     </tr>
    </table>
   </td>
  </tr>
 </table>
</body>
</html>
`

export default templateText;